import IconClose from 'assets/images/icon_close.svg';
import { DESKTOP_MIN_WIDTH } from 'constants';
import { timer } from 'helpers';
import useCountdownToActionVer2 from 'hooks/useCountdownToActionVer2';
import { useDetectDevice } from 'hooks/useDetectDevice';
import useLang from 'hooks/useLang';
import Modal from 'react-bootstrap/Modal';
import styled from 'styled-components';
import {
  displayFlexRowCenterCenterMixin,
  displayFlexRowCenterSpaceBetweenMixin,
  paragraph700Mixin,
  preventFontJumpyMixin,
} from 'styles';

const VideoModalVer2 = ({
  isOpen,
  onClose,
  onClick,
  modalStyles,
  modalOptions,
  isBackdropOverlap,
  zIndexBackdropOverlap,
  zIndexModal = 0,
}) => {
  const { t } = useLang();
  const { isDesktop } = useDetectDevice();
  const { iframeSrc, countdown } = modalOptions || {};
  const { countdown: countdownCurrent } = useCountdownToActionVer2({
    countdownInit: countdown,
    isRun: isOpen,
  });

  const renderTimeRemainingSection = () => {
    if (!countdown) return <div></div>;
    return (
      <TimeRemainingSection>
        <TimeRemainingDesc>
          {`${t('label_time_remaining')}:`}
          {` `}
          <span>
            [{timer.convertSecondsToMinuteSecondString(countdownCurrent)}]
          </span>
        </TimeRemainingDesc>
      </TimeRemainingSection>
    );
  };

  return (
    <>
      <style>
        {zIndexModal
          ? `
            .modal {
              z-index: ${zIndexModal || 1101};
            }
        `
          : ``}
        {isBackdropOverlap
          ? `
          .youtube-iframe-modal-backdrop {
            z-index: ${zIndexBackdropOverlap || 1100}!important;
            background: #212121;
            opacity: 0.7!important;
            display: initial!important;
          }
        `
          : `
        .youtube-iframe-modal-backdrop {
          background: #212121;
          opacity: 0.7!important;
          display: initial!important;
        }
      `}
      </style>
      <ModalStyled
        show={isOpen}
        onHide={onClose}
        aria-labelledby="contained-modal-title-vcenter"
        backdropClassName="youtube-iframe-modal-backdrop"
        centered
        $styles={modalStyles}
      >
        <ModalHeader>
          {renderTimeRemainingSection()}
          <CloseButtonStyled
            src={IconClose}
            width={30}
            height={30}
            onClick={onClose}
          />
        </ModalHeader>
        <IframeStyled
          id="youtube-iframe"
          src={iframeSrc}
          $styles={modalStyles}
          frameborder="0"
          scrolling="yes"
          loading="lazy"
          allowFullScreen
        />
      </ModalStyled>
    </>
  );
};

const ModalStyled = styled(Modal)`
  & .modal-dialog {
    transform: none;
    & .modal-content {
      padding: 0px;
      box-shadow: var(--ds-bs-4);
      background: var(--ds-c-white);
      margin-inline: auto;
      border: none;
      width: calc(100dvw - 32px);
      border-radius: ${(props) =>
        props.$styles?.borderRadius || 16}px!important;
    }
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    & .modal-dialog {
      max-width: fit-content;
      & .modal-content {
        width: ${(props) => props.$styles?.width || 992}px;
      }
    }
  }
`;

const IframeStyled = styled.iframe`
  width: 100%;
  overflow-y: scroll !important;
  overflow-x: hidden !important;
  height: fit-content;
  min-height: 460px;
  max-height: 80dvh;
  border-radius: ${(props) => props.$styles?.borderRadius || 14}px!important;
  padding: 0px;
  border: none;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    min-height: 582px;
    max-height: 582px;
  }
`;

const ModalHeader = styled.div`
  ${displayFlexRowCenterSpaceBetweenMixin};
  background: transparent !important;
  position: absolute;
  top: -40px;
  left: 0px;
  width: 100%;
`;
const CloseButtonStyled = styled.img`
  cursor: pointer;
  width: 30px;
  height: 30px;
`;
const TimeRemainingSection = styled.div`
  ${displayFlexRowCenterCenterMixin};
  gap: 4px;
  width: fit-content;
  height: 30px;
`;
const TimeRemainingDesc = styled.p`
  ${paragraph700Mixin};
  font-size: 24px;
  color: #fff;
  & span {
    font-family: var(--ff-tertiary);
    font-size: 24px;
    line-height: 28px;
    font-weight: 500;
    ${preventFontJumpyMixin};
  }
`;

export default VideoModalVer2;
